<template>
 <section class="article-tile-grid">
	 <div class="contained article-tile-grid-main">
	 	<div class="row">
	 		<div class="col-12">
	 			<h3 class="heading-4 w-100 text-center article-tile-grid-heading">{{title}}</h3>
	 		</div>
	 	</div>

	 	<div class="article-tile-grid-container ie-grid">

			<ArticleTile displayTile="Featured" imageUrl="/images/man_presenting.jpg" icon="eye">

				<template v-slot:title>
					Hamilton Lane Liquidity Scorecard
				</template>
				<template v-slot:description>
					It’s Market Overview season at Hamilton Lane, so we thought it’d be fun to share a small highlight from this year’s presentation…
				</template>
				<template v-slot:link>Read the blog post</template>
			</ArticleTile>

			<ArticleTile displayTile="Simple" icon="eye" heading="Insight" class="">
				<template v-slot:title>
					Rainy days, credit quality and market conditions
				</template>
				<template v-slot:description>
					In this white paper, we tackle some of the pros and cons around the current economic cycle, and take a closer look at lorem ipsum dolor…
				</template>
				<template v-slot:link>Read the WhitePaper</template>
			</ArticleTile>

			<ArticleTile displayTile="Simple" icon="eye" heading="Insight" :is-dark="true" :is-featured="true">
				<template v-slot:title>
					Stake sales: what J. lo and your gps have in common
				</template>
				<template v-slot:description>
					Has anyone ever uttered the words GPs and J. Lo in the same sentence? We certainly hadn’t - until today. In this white paper, we walk through GP stake sales and the possible characteristics they share with “Jenny from the Block.”
				</template>
				<template v-slot:link>Read the Article</template>
			</ArticleTile>

			<ArticleTile displayTile="Simple" icon="news" heading="News" >
				<template v-slot:title>
					Pensions &amp; Investments
				</template>
				<template v-slot:description>
					Pensions & Investments recently highlighted in-state investment programs including Hamilton Lane’s work with the Florida Growth Fund.
				</template>
				<template v-slot:link>Read the blog post</template>
			</ArticleTile>

			<ArticleTile displayTile="Callout" icon="eye" heading="Insight" class="">
				<template v-slot:title>
					Rainy days, credit quality and market conditions
				</template>
				<template v-slot:description>
					In this white paper, we tackle some of the pros and cons around the current economic cycle, and take a closer look at lorem ipsum dolor…
				</template>
				<template v-slot:link>Read the WhitePaper</template>
			</ArticleTile>

			<ArticleTile displayTile="Simple" icon="news" heading="News">
				<template v-slot:title>
					Pensions &amp; Investments
				</template>
				<template v-slot:description>
					Pensions & Investments recently highlighted in-state investment programs including Hamilton Lane’s work with the Florida Growth Fund.
				</template>
				<template v-slot:link>Read the blog post</template>
			</ArticleTile>

			<SubscribeTile v-if="showSubscribe" />
		</div>
	</div>
 </section>
</template>


<script>

import ArticleTile from '../components/ArticleTile.vue';
import SubscribeTile from '../components/SubscribeTile.vue';



export default {
	components: {
		ArticleTile,
		SubscribeTile
	},
	props: {
		title: {
			type: String,
			default: "Section Title"
		},
		showSubscribe: {
			type: Boolean,
			default: true
		}
	}
}

</script>

<style lang="scss">
	.ie {
		.article-tile-grid {
			.article-tile-grid-main {
				.article-tile-grid-container {
					grid-template-columns: 1fr 20px 1fr 20px 1fr !important;
					//grid-template-rows: 240px 20px !important;
					// minmax(150px, auto) 20px minmax(150px, auto) 20px minmax(150px, auto) 20px !important;
				}
			}
		}
	}

	.homepage {
		.article-tile-grid {
			.article-tile-grid-main {
				.article-tile-grid-container {
					@include respond-below(sm) {
						padding-left: 30px;
						padding-right: 30px;
					}
				}
			}
		}
	}



	.article-tile-grid {
		.article-tile-grid-heading {

			padding-top: $bigPaddingSize;
			margin-bottom: 0;

			@include respond-below(md) {
				padding-top: $bigPaddingSize/2;
			}

		}

		.article-tile-grid-main {
			padding-left: $bigPaddingSize/4;
			padding-right: $bigPaddingSize/4;
			@include respond-above(xl) {
				padding-left: $bigPaddingSize/2;
				padding-right: $bigPaddingSize/2;	
			}
			@include respond-below(md) {
				padding-left: 0;
				padding-right: 0;
			}
		}



		.article-tile-grid-container {
			padding-inline-start: 0;
			// grid-auto-flow: dense;
			display: grid;
			grid-template-columns: repeat(3, 1fr);
			grid-auto-rows: minmax(150px, auto);

			grid-gap: 25px;
			margin-top: 2rem;
			grid-auto-flow: row dense;

			@include respond-below(lg) {
				grid-template-columns: 1fr 1fr;
			}

			@include respond-below(md) {
				grid-template-columns: 1fr;
				grid-auto-rows: auto;

				// .article-tile:not(.article-tile--dark):not(.article-tile--featured) {
					// padding-top: 0 !important;
					// padding-bottom: 0 !important;
				// }
			}


			@include respond-above(lg) {
				.subscribe-fixed-pos {
					grid-row: 3 / 3;
					grid-column: 3 / 3;
				}
			}
		}
	}

	//.article-tile-grid > .ktc-widget-zone

	// fixes for kentico admin
	.ktc-section .article-tile-grid .article-tile-grid-container {
		display: flex !important;

		& > .ktc-widget-zone {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
		}
		
		& > .ktc-widget-zone > .ktc-widget {
			width: 33.3%;
		}
	}
	

// Need to update eyebrows for specific articles
// Update to ArticleTile.vue for each

</style>

